<template>
    <div>
        <div id="printJS-form" style="width:100%">
            <h3>《{{data[0].match_title}}》成绩记录</h3>
            <table style="width:100%" border>
                <thead>
                    <tr>
                        <td>排名</td>
                        <td>姓名</td>
                        <td>跳绳数</td>
                        <td>积分</td>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item,index) in data" :key="index">
                        <td>{{item.list_order}}</td>
                        <td>{{item.username}}</td>
                        <td>{{item.score_num}}</td>
                        <td>{{item.score}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
    import print from 'print-js'
    import printTableStyle from './printTableStyle';
    export default {
        props: {
            
        },
        data () {
            return {
                data:[]
            };
        },
        mounted (){
            
        },
        methods:{
            //案例
            printTables(){
                print({
                    printable: 'printJS-form',
                    scanStyles:false,
                    type: 'html',
                    style:printTableStyle(),
                    //style: '@page {margin:0 10mm};',
                    targetStyles: ['*'],
                    maxWidth:1100
                })
            },
            CreateOneFormPage(data) {                
                new Promise((resolve)=>{
                    this.data = data
                    //console.log(resolve,reject)
                    resolve('ok')
                    //根据传过来的值做一些异步的交互任务
                }).then(()=>{
                    console.log('进来了')
                    this.printTables()
                })
            },
        }
    }
</script>
<style lang="scss" scoped>
.w-100 {
    width:100%
  }
  @media print {
  .el-table{
    .el-table__body{
      width:100%!important;
    }
    th{    
      display: table-cell !important;
    }
    .cell{
      width:100%!important;
    }
  }
}

</style>